export function Footer() {
  return (
    <footer className="nowrap left-0 mx-0 flex flex-row items-center justify-center rounded-xl text-center text-[0.66rem] text-primary">
      <p className="rounded-t-xl bg-gray-500 px-4 pb-3 pt-2 dark:bg-gray-800">
        ©{new Date().getFullYear()} OGR4U 🍔 🎱 🐀
      </p>
    </footer>
  );
}
